<template>
  <div v-if="plain" class="font-size-12 blue-grey--text text--darken-3">
    <p class="mb-3 body-2 font-weight-bold">
      {{ sectionSubtitle }}
    </p>
    <p v-if="isValidated" class="paragraph mb-1">
      <span class="font-weight-700">
        {{ $t('rev.validation.total_impact') }}:</span
      >
      {{ totalImpactText }}
    </p>

    <p class="mb-1 paragraph">
      <span class="font-weight-700"> {{ timePeriodLabel }}: </span>
      {{ timePeriodValue }}
    </p>
    <p class="mb-1 paragraph">
      <span class="font-weight-700 ">{{ $t('common.category_other') }}:</span>
      {{ categories.join(', ') }}
    </p>
    <p class="mt-4 mb-2 font-weight-700 paragraph">{{ impactsLabel }}:</p>
    <div class="paragraph" v-for="impact in impacts" :key="impact.id">
      <span class="font-weight-700">{{ $t(`impacts.${impact.name}`) }} :</span>
      {{ getMetricValue(impact.value, impact.unit) }} -
      {{ getMetricFrequency(impact.frequency) }}
    </div>

    <p class="mt-4 mb-2 font-weight-700 paragraph">{{ investmentsLabel }}:</p>
    <div class="paragraph" v-for="impact in investments" :key="impact.id">
      <span class="font-weight-700">{{ $t(`impacts.${impact.name}`) }} :</span>
      {{ getMetricValue(impact.value, impact.unit) }} -
      {{ getMetricFrequency(impact.frequency) }}
    </div>

    <p class="mt-4 mb-2 paragraph">
      <span class="font-weight-700 ">
        {{ $t('rev_cycle.review.how_did_you_estimate_the_benefits') }}
      </span>
    </p>
    <p class="paragraph">{{ estimationText }}</p>
    <div v-if="isImplemented && !isValidated" class="mt-4 mb-2">
      <p class="paragraph mb-0">
        <span class="font-weight-700">{{
          $t('rev.validation.marked_as_implemented_by')
        }}</span
        >: {{ implementedBy.displayname }}
        {{ implementedBy.familyname }}
      </p>
      <p class="paragraph mb-0">
        <span class="font-weight-700">
          {{ $t('rev.validation.marked_as_implemented_on') }} </span
        >:
        {{ getDate(implementationAt) }}
      </p>
    </div>
    <div v-if="isValidated" class="mt-4 mb-2">
      <p class="paragraph mb-0">
        <span class="font-weight-700">
          {{ $t('rev.validation.validated_by') }}
        </span>
        {{ validatedBy.displayname }}
        {{ validatedBy.familyname }}
      </p>
      <p class="paragraph mb-0">
        <span class="font-weight-700">
          {{ $t('rev.validation.validated_on') }} </span
        >{{ getDate(validationAt) }}
      </p>
    </div>
  </div>
  <Card
    v-else
    class="print-impacts__card"
    data-testid="impacts_card"
    :title="sectionTitle"
  >
    <div slot="content">
      <p
        class="mb-2 font-size-12 font-weight-700 blue-grey--text text--darken-3"
      >
        {{ sectionSubtitle }}
      </p>
      <v-row no-gutters>
        <v-col class="d-flex" cols="6">
          <div v-if="isValidated" class="mr-8">
            <p
              class="mb-1 font-size-12 font-weight-700 blue-grey--text text--darken-3"
            >
              {{ $t('rev.validation.total_impact') }}:
            </p>
            <p class="font-size-11 blue-grey--text text--darken-3">
              {{ totalImpactText }}
            </p>
          </div>
          <div>
            <p
              class="mb-1 font-size-12 font-weight-700 blue-grey--text text--darken-3"
            >
              {{ timePeriodLabel }}:
            </p>
            <p class="font-size-11 blue-grey--text text--darken-3">
              {{ timePeriodValue }}
            </p>
          </div>
        </v-col>
        <v-col cols="6">
          <p
            class="mb-1 font-size-12 font-weight-700 blue-grey--text text--darken-3"
          >
            {{ $t('common.category_other') }}
          </p>
          <div class="list">
            <div
              v-for="(category, index) in categories"
              class="item"
              :key="index"
            >
              <p class="d-flex ma-0 pa-0">
                <span
                  class="material-icons font-size-14 font-weight-800 green--text mr-1"
                >
                  check
                </span>
                {{ category }}
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
      <p
        class="mt-4 mb-2 font-size-12 font-weight-700 blue-grey--text text--darken-3"
      >
        {{ impactsLabel }}:
      </p>
      <div class="list">
        <div v-for="impact in impacts" :key="impact.id" class="item">
          <span
            class="font-size-11 font-weight-700 blue-grey--text text--darken-3"
            >{{ $t(`impacts.${impact.name}`) }} :</span
          >
          {{ getMetricValue(impact.value, impact.unit) }} -
          {{ getMetricFrequency(impact.frequency) }}
        </div>
      </div>
      <p
        class="mt-4 mb-2 font-size-12 font-weight-700 blue-grey--text text--darken-3"
      >
        {{ investmentsLabel }}:
      </p>
      <div class="list">
        <div v-for="impact in investments" :key="impact.id" class="item">
          <span
            class="font-size-11 font-weight-700 blue-grey--text text--darken-3"
            >{{ $t(`impacts.${impact.name}`) }} :</span
          >
          {{ getMetricValue(impact.value, impact.unit) }} -
          {{ getMetricFrequency(impact.frequency) }}
        </div>
      </div>
      <p class="mt-4 mb-2 blue-grey--text text--darken-3">
        <span class="font-size-12 font-weight-700 ">
          {{ $t('rev_cycle.review.how_did_you_estimate_the_benefits') }}
        </span>
        {{ estimationText }}
      </p>
      <div v-if="isImplemented && !isValidated" class="mt-4 mb-2">
        <p>
          <span
            class="font-size-11 font-weight-700 blue-grey--text text--darken-3"
            >{{ $t('rev.validation.mark_as_implemented_by') }}</span
          >: {{ implementedBy.displayname }}
          {{ implementedBy.familyname }}
        </p>
        <p>
          <span
            class="font-size-11 font-weight-700 blue-grey--text text--darken-3"
          >
            {{ $t('rev.validation.marked_as_implemented_on') }} </span
          >:
          {{ getDate(implementationAt) }}
        </p>
      </div>
      <div v-if="isValidated" class="mt-4 mb-2">
        <p>
          <span
            class="font-size-11 font-weight-700 blue-grey--text text--darken-3"
          >
            {{ $t('rev.validation.validated_by') }}
          </span>
          {{ validatedBy.displayname }}
          {{ validatedBy.familyname }}
        </p>
        <p>
          <span
            class="font-size-11 font-weight-700 blue-grey--text text--darken-3"
          >
            {{ $t('rev.validation.validated_on') }} </span
          >{{ getDate(validationAt) }}
        </p>
      </div>
    </div>
  </Card>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import currencies from '@/locales/currencies.json'
import { mapGetters } from 'vuex'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'
import revMixin from '@/mixins/revMixin.vue'

import Card from '@/components/RevPrint/Card'

export default {
  name: 'PrintImpacts',

  mixins: [revMixin, mixin],

  components: {
    Card,
  },

  props: {
    rev: {
      type: Object,
      required: true,
    },
    plain: Boolean,
  },

  data() {
    return {
      rules: [],
    }
  },

  mounted() {
    this.getImpactMetrics()
  },

  computed: {
    ...mapGetters(['organizationId']),

    revCurrency() {
      return this.getRevCurrency(this.rev)
    },

    currencySymbol() {
      return _.get(currencies[this.revCurrency], 'symbol_native', '')
    },

    isImplemented() {
      return this.isRevValidated(this.rev)
    },

    isValidated() {
      return this.isFinanciallyValidated(this.rev)
    },

    sectionTitle() {
      return this.isValidated
        ? this.$t('common.validation')
        : this.$t('common.review')
    },

    sectionSubtitle() {
      return this.isValidated
        ? this.$t('rev.validation.impact_validated')
        : this.$t('rev.validation.estimated_impact')
    },

    totalImpactText() {
      const totalImpact = this.rev?.validatedReview?.totalImpact ?? null

      return totalImpact
        ? `
          ${this.currencySymbol}
          ${Number(totalImpact).toLocaleString(navigator.language)}
          ${this.revCurrency}
          `
        : '-'
    },

    timePeriodLabel() {
      const timePeriod = this.$t('common.time_period')
      return this.isValidated
        ? timePeriod
        : `${timePeriod} (${this.$t('rev.validation.estimated')})`
    },

    timePeriodValue() {
      const startDate = moment(this.rev?.impactStartsAt)
      const endDate = moment(this.rev?.impactEndsAt)
      if (!startDate.isValid() || !endDate.isValid()) return '-'
      return `${startDate.format('ll')} - ${endDate.format('ll')}`
    },

    impactsLabel() {
      const impacts = this.$t('rev.impacts.impact_other')
      return this.isValidated
        ? impacts
        : `${impacts} (${this.$t('rev.validation.estimated')})`
    },

    impacts() {
      const impacts = this.isValidated
        ? this.rev?.validatedReview?.impacts ?? []
        : this.rev?.reviewPhase?.impacts ?? []
      return impacts.map(impact => {
        const rule = this.rules.find(rule => rule?.metric?.id === impact.id)
        return {
          ...impact,
          name: rule?.metric?.name ?? '',
        }
      })
    },

    investmentsLabel() {
      const impacts = this.$t('rev_cycle.review.investment')
      return this.isValidated
        ? impacts
        : `${impacts} (${this.$t('rev.validation.estimated')})`
    },

    investments() {
      const investments = this.isValidated
        ? this.rev?.validatedReview?.investments ?? []
        : this.rev?.reviewPhase?.investments ?? []
      return investments.map(investment => {
        const metric = this.$constants.investments.find(
          metric => metric?.id === investment.type
        )
        return {
          id: investment.type,
          ...investment,
          name: metric?.name ?? '',
        }
      })
    },

    estimationText() {
      return this.isValidated
        ? this.rev?.validatedReview?.estimationExplanation
        : this.rev?.comments ?? this.rev?.reviewPhase?.estimationExplanation
    },

    implementedBy() {
      return (
        this.rev?.validations__implementation__validatedBy ??
        this.rev?.validations?.implementation?.auditor ??
        {}
      )
    },

    implementationAt() {
      return (
        this.rev?.validations__implementation__validatedAt ??
        this.rev?.validations?.implementation?.createdAt
      )
    },

    validatedBy() {
      return (
        this.rev?.validations__financial__validatedBy ??
        this.rev?.validations?.financial?.auditor ??
        {}
      )
    },

    validationAt() {
      return (
        this.rev?.validations__financial__validatedAt ??
        this.rev?.validations?.financial?.createdAt
      )
    },

    categories() {
      return this.rev?.categories?.map(category => {
        return category?.text ?? this.$t(`common.categories.${category}`)
      })
    },
  },

  methods: {
    async getImpactMetrics() {
      try {
        const { data } = await api.metrics.getRules(this.organizationId)
        this.rules = data
      } catch (err) {
        this.handleRequestError(err)
      }
    },

    getMetricValue(value, unit) {
      if (!value) return ''
      if (!unit) return value
      if (unit === this.$constants.metricUnitTypes.currency) {
        return `${this.currencySymbol}
                ${Number(value).toLocaleString(navigator.language)}
                ${this.revCurrency}`
      }

      if (unit === this.$constants.metricUnitTypes.percentage) {
        return `${value} %`
      }

      const unitText = this.$t(`impact_units.${unit}`)
      return `${value} ${unitText}`
    },

    getMetricFrequency(frequency) {
      if (!frequency) return ''
      return frequency === 'one_time'
        ? this.$t('impact_recurrence.one_time_only')
        : this.$t(`impact_recurrence.${frequency}`)
    },

    getDate(data) {
      const date = moment(data)
      if (!date.isValid()) return '-'
      return date.format('ll')
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  display: flex;
  flex-wrap: wrap;
  .item {
    flex: 0 1 50%;
  }
}
</style>
